import React, { useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

const Notification = () => {
  const { isLoading, error, data } = useSelector((state) => state.residentlog);
  const arrayOfData = data ? data?.data : "";
  const formatDate = (dateStr) => {
    let originalDate = new Date(dateStr);
    var options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Europe/Istanbul",
    };
    return new Intl.DateTimeFormat("en-US", options)
      .format(originalDate)
      .replace(/T/g, "__T: ");
  };

  const sortedData = useMemo(() => {
    let sortableItems = [];
    try {
      sortableItems = [...arrayOfData];
    } catch (error) {
      console.log("error with data: ", error);
      // setErrorHandler();
    }
    sortableItems.sort((a, b) => {
      let dateA =
        a.status === "NEW" ? new Date(a.createdDate) : new Date(a.updatedDate);
      let dateB =
        b.status === "NEW" ? new Date(b.createdDate) : new Date(b.updatedDate);

      // Sorting in descending order
      return dateB - dateA;
    });

    return sortableItems.map((item) => ({
      ...item,
      createdDate: formatDate(item.createdDate),
      updatedDate: formatDate(item.updatedDate),
    }));
  }, [arrayOfData]);

  const separateDateAndTime = (dateString, timeString) => {
    const date = new Date(dateString);
    const datePart = date.toLocaleDateString();
    const timePart = timeString ? timeString : date.toLocaleTimeString();
    return { datePart, timePart };
  };



  return (
    <div className="flex flex-col max-h-[400px] md:w-[462px] sm:w-[370px] w-[340px] border rounded-t-lg rounded-b-lg bg-white rounded-tl-lg shadow-3xl shadow-nidblue overflow-scroll scrollbar-hide">
      <div className="py-2 font-bold text-center text-nidblue border- shadow-nidblue border-b-2">
        <p>UPDATE REQUEST STATUS</p>
      </div>
      {isLoading ? (
        <p className="flex items-center w-full text-center text-nidblue justify-center font-semibold text-lg animate-pulse">
          Loading...
        </p>
      ) : error ? (
        <p className="text-nidblue text-center">Error: {error}</p>
      ) : data ? (
        arrayOfData?.length > 0 ? (
          <div className="flex flex-col font-semibold w-full md:max-w-[600px] max-w-[370px] overflow-y-scroll b-slate-400">
            {sortedData?.slice().map((item) => {
              const dateToShow =
                item.status === "NEW" ? item.createdDate : item.updatedDate;
              const { datePart, timePart } = separateDateAndTime(dateToShow);
              if (item.status === "INCOMPLETE") {
                return null; // Skip this item
              }

              let statusText;
              let statusColorClass;
              if (item.status === "SUBMITTED") {
                statusText = "Update Request is under review";
                statusColorClass = "text-nidblue";
              } else if (item.status === "DECLINED") {
                statusText = "Update Request has been Rejected";
                statusColorClass = "text-red-600 ";
              } else if (item.status === "APPROVED") {
                statusText =
                  "Update Request has been Approved, Updating process might take upto 48 hours.";
                statusColorClass = "text-nidblue text-bold";
              }

              return (
                <>
                  <div
                    className="flex flex-col w-full pl-5 pr-2 text-lg border-t-2 border-gray-200 b-slate-700 hover:bg-gray-100 curs"
                    key={item.id}
                  >
                    <div
                      className={`font-bold ${statusColorClass} flex w-full text-xl`}
                    >
                      {item.status}
                    </div>
                    <div
                      className={`font-bold ${statusColorClass} flex w-full text-xl`}
                    >
                      {statusText}
                    </div>

                    {item.reason !== null && item.status === "DECLINED" ? (
                      <div className="flex flex-wrap text-MetallicBlue">
                        <h1 className="pr-2 font-bold ">Reason :</h1>
                        <div className="bg-amber-5 w-full max-w-fit whitespace-normal break-words">
                          {item.reason}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="flex text-MetallicBlue text-base">
                      <h1 className="pr-2 font-bold ">Date :</h1>
                      <div className="pr-2"> {datePart} </div>
                      <h1 className="pr-2 font-bold ">Time :</h1>
                      <div className=""> {timePart} </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        ) : (
          <p className="flex items-center w-full text-center text-nidblue justify-center font-semibold">
            No update requests
          </p>
        )
      ) : (
        ""
      )}
    </div>
  );
};

export default Notification;
